// extracted by mini-css-extract-plugin
export default {"content-right":"ContentRight_content-right__w68SD","item":"ContentRight_item__-cGH-","content-hot":"ContentRight_content-hot__JWmL0"};